import styled from 'styled-components';

import {
    ModalDialog,
} from '@zillow/constellation';

export const StyledModalDialog = styled(ModalDialog)`
    && [class^="DialogBody"] {
        padding: ${props => props.theme.ns().spacing.xs()} ${props => props.theme.ns().spacing.sm()};

        padding-left: ${props => props.isFluid && 0};
        padding-right: ${props => props.isFluid && 0};

        overflow-x: hidden;
    }
`;

export const StyledModalSection = styled.div`
    max-width: 550px;
    margin: 0 auto;
`;
